module.exports = __webpack_public_path__ + "media/theme/icon__mail-e5dcbcd4.svg";